import React from 'react';
import Header from "../components/Header";
import styled from "styled-components";
import Footer from "../components/Footer";
import NetworkPromotionScreenIframeTranzila from "../components/NetworkPromotionScreenIframeTranzila";

const Page = styled.div`
  width: min(1920px, 100%);
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
`;

function NetworkPromotionPage(props) {
    return (
        <Page>
            <Header lightVersion/>
            <NetworkPromotionScreenIframeTranzila/>
            <Footer/>
        </Page>
    );
}

export default NetworkPromotionPage;


